import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

export interface Parent {
  course_title: string;
  trainer_title: string;
  id?: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'BKHydra';
  servicedate: any = [];
  constructor(private router: Router, private afs: AngularFirestore) {
    this.router.events.subscribe((evt) => {
      window.scrollTo(0, 0);
    });
    const service: AngularFirestoreCollection<Parent> = this.afs.collection<Parent>('Parent', res => {
      return res.orderBy('createdAt', 'asc');
    });
    this.servicedate = service.snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Parent;
          data.id = a.payload.doc.id;
          console.log(data);
          return data
        });
      });


  }


}
